import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Chip, Tooltip } from "@mui/material";

type Props = {
  label: string;
  tooltip: string;
};

const SystemLabel = ({ label, tooltip }: Props) => (
  <Chip
    variant="status"
    label={label}
    size="small"
    color="default"
    icon={
      <Tooltip title={tooltip} arrow>
        <InfoOutlinedIcon />
      </Tooltip>
    }
  />
);

export default SystemLabel;
